import { Injectable } from "@angular/core";
import { TokenStorageService } from "../auth/token/token-storage.service";
import { ReleaseLicenseConfigurationService } from "src/app/shared/configuration/auth/logout/release-license/release-license-configuration.service";
import { RegionStorageService } from "../region/region-storage.service";
import { AuthorizationHeaderFactoryService } from "../http/headers/authorization-header-factory.service";
import { SuperBatmanHeaderFactoryService } from "../http/headers/super-batman-header-factory.service";
import { AcceptHeaderFactoryService } from "../http/headers/accept-header-factory.service";
import { AuthorityService } from "../auth/authority/authority.service";

@Injectable({
  providedIn: "root",
})
export class ReleaseLicenseService {
  get path() {
    return this.releaseLicenseConfiguration.path;
  }

  get releaseLicenseConfiguration() {
    return this.releaseLicenseConfigurationService.configuration;
  }

  constructor(
    private tokenStorageService: TokenStorageService,
    private releaseLicenseConfigurationService: ReleaseLicenseConfigurationService,
    private regionStorageService: RegionStorageService,
    private authHeaderFactoryService: AuthorizationHeaderFactoryService,
    private superbatmanHeaderFactoryService: SuperBatmanHeaderFactoryService,
    private acceptHeaderFactoryService: AcceptHeaderFactoryService,
    private authorityService: AuthorityService
  ) {}

  loadRegion() {
    return this.regionStorageService.loadRegion();
  }

  releaseLicense() {
    return fetch(this.createResourceUrl(), {
      method: "GET",
      keepalive: true,
      headers: {
        ...this.createAuthHeader(),
        ...this.createSuperBatmanHeader(),
        ...this.createAcceptJsonHeader("application/json"),
      },
    });
  }

  createAuthHeader() {
    return this.authHeaderFactoryService.createHeader();
  }

  createAcceptJsonHeader(value) {
    return this.acceptHeaderFactoryService.createHeader(value);
  }

  createSuperBatmanHeader() {
    return this.superbatmanHeaderFactoryService.createHeader();
  }

  loadToken() {
    return this.tokenStorageService.loadToken();
  }

  createResourceUrl() {
    return this.authorityService.createResourceUrl(this.path);
  }
}
